import styled, { css } from 'styled-components';
import { getSpace, gridContainer, setGridColumns, mq } from '../../../stylesheets/tools';

const StyledInfoGraphicGroup = styled.div`
  margin: ${getSpace('l')} 0;

  ${props =>
    props.layout === 'horizontal' &&
    css`
      grid-gap: 36px;

      ${mq('l')} {
        grid-gap: 24px;
      }
      ${gridContainer()}
      ${setGridColumns('1fr', 1, {
        l: ['1fr', 3]
      })}
    `}
`;

export default StyledInfoGraphicGroup;
